import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
	Link,
	// Redirect
} from 'react-router-dom';
import { connect } from 'react-redux';
import {
	Container,
	Row,
	Form,
	Input,
	Col,
	Card,
	CardBody,
	CardTitle,
	CardText,
	CardHeader,
	FormGroup,
	Label,
	CardFooter,
	Alert,
  Button as ButtonBootstrap
} from 'reactstrap';
import classNames from 'classnames';
import styled from 'styled-components';
import {GoogleLogin} from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

import { doSignIn, doSocialSignIn } from '../../actions/authAction';
import '../../styles/scss/Login.scss';

import { FormFeedback, Button as ButtonSubmit } from '../Forms';
import { isEmail } from '../../helpers/regex';
import { Clipboard } from '../../helpers/clipboard';

import FontAwesome from 'react-fontawesome';
import Google from '../../images/google.png'
import IconClose from '../../images/cross.png';
import eyeOpen from '../../images/eye-open.png';
import eyeClose from '../../images/eye-close.png';

import {REDIRECT_FB_MOBILE, API_BASE_URL, IS_FROM_WEB_APPS} from '../../constants'

const myClipboard = new Clipboard(window, document, navigator)

class pageLogin extends React.Component {
	constructor(props) {
		super(props);
		const queries = new URLSearchParams(this.props.location.search);
		this.state={
			email:'',
			password:'',
			_submitSignin:false,
      _submitSocial: false,
			_error:null,
			_shouldRedirect:false,
			_redirectTo: this.props.location.search? queries.get('next'):
				(this.props.location.state && this.props.location.state.next? this.props.location.state.next:'/'),
			onCopyMode: false,
			copyActionMessage: '',
      url: window.location.origin || (window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '')),
      visiblePassword: false
		};
		this.onChange = this.onChange.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.toggleVisible=this.toggleVisible.bind(this);
	}

	componentDidMount(){
		if(this.props.dataAuth.isLogged===true){
			this.setState({'_shouldRedirect':this.props.dataAuth.isLogged});
		}
	
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.dataSignIn.isSubmit===false
			&& nextProps.dataSignIn.isSubmit!==this.props.dataSignIn.isSubmit
			&& this.state._submitSignin===true
		){
			if(nextProps.dataSignIn.error){
				if(nextProps.dataSignIn.error.status_code===401){
					this.setState({_error:{ errors:{ password:['Incorrect password.']}, status_code:422 }, _submitSignin:false})
				}
				else{
					this.setState({_error:{...nextProps.dataSignIn.error},_submitSignin:false})

				}
			}
			else{
				this.setState({_shouldRedirect:nextProps.dataAuth.shouldRedirect,_submitSignin:false})
				if(nextProps.dataAuth.shouldRedirect) this.props.history.replace(this.state._redirectTo)
			}
		}
	}

	_renderSocmedLogin = () => {
		let { onCopyMode } = this.state 		
		let isFromAppBrowser = this.isFromWebApps()

		return !isFromAppBrowser ? this._renderBrowserLoginWithSocmed() : 
		(onCopyMode ? this._renderOnCopyMode() : this._renderSocmedButtonInApp() )

	}

	// _renderSocmedButtonBrowser = () => {
	// 	return (
	// 		<Row className="auth-social">
	// 			<Col xs={12} sm={12} md={12} lg={5} className={classNames('col-auth-fb',{'disabled': (this.state._submitSocial || this.state._submitSignin)})}>
	// 				<FacebookLogin
	// 					appId="1588115344582034"
	// 					fields="name,email,verified"
	// 					version="2.12"
	// 					disableMobileRedirect={true}
	// 					scope="public_profile,email"
	// 					onFailure={this._failureFacebook}
	// 					callback={this._responseFacebook}
	// 					isDisabled={(this.state._submitSocial || this.state._submitSignin)}
	// 					render={(props)=>(
	// 						<div className="auth-facebook" onClick={props.onClick}>
	// 							<FontAwesome name="facebook" style={{fontSize: "1rem", color: "#ffffff", marginRight: "10px"}}/>
	// 							<span className="text-auth-facebook">Masuk Dengan Facebook</span>
	// 						</div>
	// 					)}
	// 				/>
	// 			</Col>
	// 			<Col xs={12} sm={12} mg={12} lg={2} style={{textAlign: "center"}} className="col-or">
	// 				<span>OR</span>
	// 			</Col>
	// 			<Col xs={12} sm={12} md={12} lg={5} className="col-auth-google">
	// 				<GoogleLogin
	// 					clientId="594858415021-kion5vibkgo9kf91toajjcb6h7ltt4aq.apps.googleusercontent.com"
	// 					onSuccess={this._responseGoogle}
	// 					onFailure={this._responseGoogle}
	// 					className="auth-google"
	// 					disabled={(this.state._submitSocial || this.state._submitSignin)}
	// 					disabledStyle={{opacity: 0.65}}
	// 				>
	// 					<KickImage src={Google} alt="Google" />
	// 					<span className="text-auth-google">Masuk Dengan Google</span>
	// 				</GoogleLogin>
	// 			</Col>
	// 		</Row>
	// 		)
	// }

	_renderSocmedButtonInApp = () => {
		return (		
			<Row className="auth-social">
				<p style={{width: '100%', textAlign: 'center'}}>LOGIN WITH</p>
				<Col xs={6}>
					<div  className={classNames('col-auth-fb',{'disabled': (this.state._submitSocial || this.state._submitSignin)})}>
						<div className="auth-facebook" onClick={this.onCopyMode}>
							<span className="text-auth-facebook">FACEBOOK</span>
						</div>
					</div>					
				</Col>

				<Col xs={6} className="col-auth-google">
						<div className="auth-facebook" onClick={this.onCopyMode}>
							<span className="text-auth-google">GOOGLE +</span>
						</div>
				</Col>
			</Row>
		)
	}

	_renderOnCopyMode = () => {
		let { copyActionMessage } = this.state
		return (
			<Row className="mb20">
				<Col>
					<Card>
						<p className="text-right" style={{margin:'10px', marginBottom:'0'}}>
							<KickImage id="icon-home" src={IconClose} style={{width:'30px'}} onClick={this.closeCopyMode} alt="Home"/>
						</p>
						<CardBody>
							<Alert color="warning">
							Maaf, in-app browser tidak mendukung login dengan sosial media. Silahkan tekan tombol "Copy Text", tutup app ini dan paste kan di browser kesukaan <strong>anda</strong>.
							</Alert>
							<Input type="textarea" name="text" id="urlLink" style={{marginBottom: '15px'}}value={`${this.state.url}/login?next=/promo/reactxdisruptor`} />
							
							{
								!!copyActionMessage && 
								<Alert color="success">
									{ copyActionMessage }
								</Alert>
							}
							<ButtonBootstrap onClick={this.copyToClipBoard}>Copy Text</ButtonBootstrap>
						</CardBody>
					</Card>					
				</Col>
			</Row>
		)
		
	}

	copyToClipBoard = () => {
		let input = document.getElementById("urlLink"),
				val 	= input.value

		if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
			myClipboard.copy(val);
		}
		else{
			input.select();
			document.execCommand("copy");
		}
		this.setState({
			copyActionMessage: "Text Copied! Silahkan paste di browser chrome/browser kesukaan di hp anda"
		});
	}

	onCopyMode = () => {
		this.setState({
			onCopyMode: true
		})
	}

	closeCopyMode = () => {
		this.setState({
			onCopyMode: false
		})
	}

	_validateForm(){
		let errors={};
        if(this.state.email==='')
            errors['email']=errors['email']!==undefined?[...errors.email,'Input your email.']:['Input your email.'];
		if(!isEmail(this.state.email))
			errors['email']=errors['email']!==undefined?[...errors.email,'Incorrect email.']:['Incorrect email.'];
        if(this.state.password==='')
            errors['password']=errors['password']!==undefined?[...errors.password,'Input your password.']:['Input your password.'];
        if(Object.keys(errors).length){
            this.setState({
                _error:{errors:{...errors}, status_code:422,message:'Incorrect login, please check and try again.'}
            })
        }
        return errors;
	}

  _responseGoogle = (googleUser) => {
		// console.log("googleUser response: ", googleUser);
    if(!googleUser.hasOwnProperty('error')){
      const { tokenId, profileObj } = googleUser
      const dataUser = {
        id: profileObj.googleId,
        email: profileObj.email,
				typed_email: profileObj.email,
				oauth_token: tokenId,
        type: "google",
				name: profileObj.name
      }
      this.setState({_submitSignin: true, _submitSocial: true},()=>{
        this.props.doSocialSignIn(dataUser)
      })
    }

      return null
  }

  _responseFacebook = (facebookUser) => {
    if(!facebookUser.hasOwnProperty('status')){
      const dataUser = {
        id: facebookUser.id,
        email: facebookUser.email,
        typed_email: facebookUser.email,
				type: "facebook",
				oauth_token: facebookUser.accessToken,
				name: facebookUser.name
      }
      this.setState({_submitSignin: true, _submitSocial: true},()=>{
        this.props.doSocialSignIn(dataUser)
      })
    }

    return null
  }

  _failureFacebook = (facebookUser) => {
    return null
  }

	_renderError(){
        const {_error} = this.state;
        if(_error!==null){
            switch(_error.status_code){
                case 422:
                    return <Alert color="danger">Incorrect login, please check and try again.</Alert>
                default:
                    return <Alert color="danger">We got something error. Please inform our Admin through live chat.</Alert>

            }
        }
        return null;
	}

    _hasError(name){
        if(this.state._error!==null&&this.state._error.status_code===422){
            return Object.keys(this.state._error.errors).filter(err=>err===name).length>0;
        }
        return false;
	}

	onChange(e) {
		this.setState({
			[e.target.name]: e.target.value
		});
	}
	onLogin(e) {
		e.preventDefault();
		this.setState({ _error:null });
		if(Object.keys(this._validateForm()).length===0){
			this.setState({_submitSignin:true},()=>{
				this.props.doSignIn(this.state);
			})
		}
	}
	isFromWebApps = () => {		
		let localValue = localStorage.getItem(IS_FROM_WEB_APPS)
		return this.props.isWebApp || localValue === 'true' 
  }
  
  toggleVisible(){
    this.setState({
      visiblePassword: !this.state.visiblePassword
    })
  }

	/* New UI */
	_renderBrowserLoginWithSocmed = () => {
		return (
			<Row className="auth-social">
				<p style={{width: '100%', textAlign: 'center'}}>LOGIN WITH</p>
				<Col xs={6} sm={6} md={6} lg={6} >
					<div className={classNames('col-auth-fb',{'disabled': (this.state._submitSocial || this.state._submitSignin)})}>
						<FacebookLogin
							appId="1588115344582034"
							fields="name,email,verified"
							version="2.12"
							disableMobileRedirect={true}
							scope="public_profile,email"
							onFailure={this._failureFacebook}
							callback={this._responseFacebook}
							isDisabled={(this.state._submitSocial || this.state._submitSignin)}
							render={(props)=>(
								<div className="auth-facebook" onClick={props.onClick}>
									<span className="text-auth-facebook">FACEBOOK</span>
								</div>
							)}
						/>
					</div>					
				</Col>

				<Col xs={6}>
					<div className="col-auth-google">
						<GoogleLogin
							clientId="594858415021-kion5vibkgo9kf91toajjcb6h7ltt4aq.apps.googleusercontent.com"
							onSuccess={this._responseGoogle}
							onFailure={this._responseGoogle}
							className="auth-google"
							disabled={(this.state._submitSocial || this.state._submitSignin)}
							disabledStyle={{opacity: 0.65}}
						>
							<span className="text-auth-google">GOOGLE+</span>
						</GoogleLogin>
					</div>                            
				</Col>
			</Row> 
		)
	}
	_renderLogin = () => {
		let { sections, visiblePassword } = this.state
		return (
			<Row  >
				<Col>
					<FormGroup>
						<Label for="email">Email</Label>
            <Input autoComplete="off"  type="email" name="email" id="email" onChange={this.onChange}/>
            <div style={{ height: "20px" }}>
            <TextError>{this.state._error!==null? (this.state._error.errors.email!==undefined?this.state._error.errors.email[0]: null) : null}</TextError>
            </div>
					</FormGroup>

					<FormGroup>
						<Label for="password">Password</Label>
            <div style={{ position: "absolute", width: "92%" }}>
            <Input type={visiblePassword? "text" : "password"} name="password" id="password" onChange={this.onChange} />
						<KickImage 
            // className={classNames("img-eye", {"with-error": this.state._error!==null})} 
            className={classNames("img-eye")} 
            src={visiblePassword? eyeOpen : eyeClose} onClick={this.toggleVisible} alt="visible-password"/>
            <div style={{height: "20px"}}>
            <TextError>{this.state._error!==null? (this.state._error.errors.password!==undefined?this.state._error.errors.password[0]: null) : null}</TextError>
            </div>
            </div>
					</FormGroup>
					<p className="text-right" style={{marginTop: "60px"}}>
					<Link to="/forgot-password" className="text-black green-link d-block text-right">Forgot Password ?</Link>
					</p>
					<div className="bottom-link">
						<p>Have not been registered yet?</p>
						You can <Link to={`/register${this.props.location.search}`} className="text-black green-link d-inline-block">click here to <b>REGISTER</b></Link>
					</div>

					<ButtonSubmit size="lg" className="btn-green mt20 bold" buttonText="Login" disabled={this.state._submitSignin===true} block social={this.state._submitSocial}/>
				</Col>
			</Row>
		)
	}
	render() {
		return (
			<div>
				<Container className="main-container page-container login-page" id="modal-login-register">
					<Row>
						<Col xs="12" md="6" className="borderRight">
							<div>
								<KickImage src="/images/shoe-cartoon.png" width="100%" />
							</div>
						</Col>
						<Col xs="12" md="6">
							<Form onSubmit={this.onLogin} autoComplete="nope">
								{this._renderSocmedLogin()}                        
								{this._renderLogin()}
							</Form>                     
						</Col>
					</Row>                 
					
				</Container>
			</div>
		);
	}
}

const TextError = styled.span`
  font-size: .65rem;
  color: #dc3545;
`;

const mapStateToProps = ({loginReferralReducer, dataAuth:{ signIn, isLogged, shouldRedirect }}) => ({
	dataSignIn : signIn,
	dataAuth: { isLogged, shouldRedirect},
	isWebApp: loginReferralReducer.loginReferral.isWebApp
})

const mapDistpatchToProps = dispatch => {
	return {
		doSignIn: user => dispatch(doSignIn(user)),
    doSocialSignIn: user => dispatch(doSocialSignIn(user))
	}
}

export default connect(mapStateToProps, mapDistpatchToProps)(pageLogin);